import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IComparisonToastPayload } from '../types/comparisonToast';

export interface IComparisonToastState {
  /**
   * Данные тоста, пришедшие из выдачи в iframe.
   */
  toast: IComparisonToastPayload | null;
}

const initialState: IComparisonToastState = {
  toast: null,
};

export const comparisonToastSlice = createSlice({
  name: 'comparisonToast',
  initialState,
  reducers: {
    showComparisonToast: (state, action: PayloadAction<IComparisonToastPayload>) => {
      state.toast = action.payload;
    },
    clearComparisonToast: state => {
      state.toast = null;
    },
  },
});

export const { showComparisonToast, clearComparisonToast } = comparisonToastSlice.actions;
export const comparisonToastReducer = comparisonToastSlice.reducer;

export type TComparisonToastActions = ReturnType<typeof showComparisonToast> | ReturnType<typeof clearComparisonToast>;
